import { render, staticRenderFns } from "./Residency.vue?vue&type=template&id=f6b49bca&"
import script from "./Residency.vue?vue&type=script&lang=js&"
export * from "./Residency.vue?vue&type=script&lang=js&"
import style0 from "./Residency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports